import React, { Component } from "react";
import {
  Button,
  Container,
  Divider,
  Form,
  Header,
  Icon,
  Image,
  List,
  Loader,
  Menu,
  Modal,
  Segment,
  Table
} from "semantic-ui-react";
import { capitalize, kebabCase } from "lodash";
import queryString from "query-string";
import booleanify from "booleanify";
import { sortBy } from "lodash";
import moment from "moment";
import numeral from "numeral";
import ReactTable from "react-table";

function sumStringsToFloats(...stringValues) {
  return stringValues
    .reduce((prev, curr) => prev + parseFloat(curr), 0)
    .toFixed(2);
}

class ReporteAvanzado extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: null,
      records: [],
      total: 0
    };

    this.BusquedaService = this.props.feathers.service(
      "/api/busqueda-informe-avanzado"
    );
  }

  findCooperativas(search) {
    this.setState({
      loading: true
    });

    const findLastAsamblea = (asambleas = []) => {
      if (asambleas.length === 0) {
        return "";
      }

      let lastAsamblea = asambleas[0];

      asambleas.forEach(asamblea => {
        if (
          moment(asamblea.fechaAsamblea).isAfter(
            moment(lastAsamblea.fechaAsamblea)
          )
        ) {
          lastAsamblea = asamblea;
        }
      });

      return lastAsamblea.fechaAsamblea;
    };

    this.BusquedaService.find({
      query: {
        ...search,
        limit: 99999
      }
    })
      .then(response => {
        this.setState({
          loading: false,
          records: sortBy(response.records, c =>
            parseInt(c.matriculaNacional)
          ).map(record => ({
            ...record,
            fechaAsamblea: findLastAsamblea(record.asambleas),
            asociados: record.asociados.length,
            nombreSector: record.sector ? record.sector.nombre : "",
            nombreRubro: record.sector ? record.sector.rubro.nombre : "",
            nombreLocalidad: record.localidad ? record.localidad.nombre : "",
            nombreDepartamento: record.localidad
              ? record.localidad.departamento.nombre
              : ""
          })),
          total: response.total
        });
      })
      .catch(error => {
        this.setState({
          loading: false,
          error
        });
      });
  }

  componentDidMount() {
    let search = queryString.parse(window.location.search);

    this.findCooperativas(search);
  }

  render() {
    let { loading, error, records, total, headers, open } = this.state;

    let search = queryString.parse(window.location.search);
    let situacion = null;
    let dpto = null;
    let rubro = null;
    let sector = null;
    let eeconomicoFilter = null;

    if (loading) {
      return <Loader active inline="centered" />;
    }

    if (search.situacion && records.length !== 0) {
      situacion = search.situacion;
    }

    if (search.departamento && records.length !== 0) {
      dpto = records[0].localidad.departamento.nombre;
    }

    if (search.rubro && records.length !== 0) {
      rubro = records[0].sector.rubro.nombre;
    }

    if (search.sector && records.length !== 0) {
      sector = records[0].sector.nombre;
    }

    if (search.eeconomicoFilter && records.length !== 0) {
      eeconomicoFilter = search.eeconomicoFilter;
    }

    const coops = records
      .filter(c => c.eeconomicos)
      .map(cooperativa => ({
        id: cooperativa.id,
        nombre: cooperativa.nombre,
        eeconomico: cooperativa.eeconomicos[0],
        estadoSituacionPatrimonial: numeral(
          numeral(
            sumStringsToFloats(
              sumStringsToFloats(
                cooperativa.eeconomicos[0].estadoSituacionPatrimonial
                  .cajaBancos,
                cooperativa.eeconomicos[0].estadoSituacionPatrimonial
                  .creditosAC,
                cooperativa.eeconomicos[0].estadoSituacionPatrimonial
                  .bienesCambioAC
              ),
              sumStringsToFloats(
                cooperativa.eeconomicos[0].estadoSituacionPatrimonial
                  .creditosANC,
                cooperativa.eeconomicos[0].estadoSituacionPatrimonial
                  .bienesCambioANC,
                cooperativa.eeconomicos[0].estadoSituacionPatrimonial
                  .bienesUsoANC
              )
            )
          ).value() -
            numeral(
              sumStringsToFloats(
                cooperativa.eeconomicos[0].estadoSituacionPatrimonial.deudasPC,
                cooperativa.eeconomicos[0].estadoSituacionPatrimonial.deudasPNC
              )
            ).value()
        ).value(),
        estadoResultados: numeral(
          sumStringsToFloats(
            cooperativa.eeconomicos[0].estadoResultados.ingresosVentas,
            cooperativa.eeconomicos[0].estadoResultados.costoVentas,
            cooperativa.eeconomicos[0].estadoResultados.egresosComercializacion,
            cooperativa.eeconomicos[0].estadoResultados.egresosAdministracion,
            cooperativa.eeconomicos[0].estadoResultados.egresosFinancieros,
            cooperativa.eeconomicos[0].estadoResultados.egresosFiscales,
            cooperativa.eeconomicos[0].estadoResultados.egresosGenerales,
            cooperativa.eeconomicos[0].estadoResultados
              .ingresosIndirectamenteAtribuidos,
            cooperativa.eeconomicos[0].estadoResultados
              .gastosIndirectamenteAtribuidos,
            cooperativa.eeconomicos[0].estadoResultados.ingresosExtraordinarios
          )
        ).value()
      }));

    return (
      <Container fluid>
        <Image
          centered
          style={{ maxHeight: 100 }}
          src={require("../../../assets/img/logo_dgc.jpg")}
        />
        <Header
          dividing
          size="tiny"
          style={{ margin: 0 }}
          subheader="Peru 1186 - Corrientes - dircoopctes@gmail.com - Tel. 0379-4431360 / 4476041"
          textAlign="center"
        />
        <Header style={{ margin: 0 }} as="h4" textAlign="center">
          Información no certificada por el Estado Provincial
        </Header>
        <Header as="h3" textAlign="center">
          LISTADO DE COOPERATIVAS ({records.length})
        </Header>
        <List bulleted horizontal>
          {situacion && (
            <List.Item>
              <strong>SITUACION</strong> : {situacion}
            </List.Item>
          )}
          {dpto && (
            <List.Item>
              <strong>DEPARTAMENTO</strong> : {dpto}
            </List.Item>
          )}
          {rubro && (
            <List.Item>
              <strong>RUBRO</strong> : {rubro}
            </List.Item>
          )}
          {sector && (
            <List.Item>
              <strong>SECTOR</strong> : {sector}
            </List.Item>
          )}
          {eeconomicoFilter && (
            <List.Item>
              <strong>CIERRE ECONOMICO</strong> : {eeconomicoFilter}
            </List.Item>
          )}
        </List>
        <Divider />
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell content="Nombre" />
              <Table.HeaderCell content="Ejercicio" />
              <Table.HeaderCell content="Cierre" />
              <Table.HeaderCell content="Patrimonial" />
              <Table.HeaderCell content="Resultados" />
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {coops.map(cooperativa => (
              <Table.Row key={cooperativa.id}>
                <Table.Cell>{cooperativa.nombre}</Table.Cell>
                <Table.Cell textAlign="right">
                  {cooperativa.eeconomico.nroEjercicio}
                </Table.Cell>
                <Table.Cell>{cooperativa.eeconomico.fechaFin}</Table.Cell>
                <Table.Cell textAlign="right">
                  {numeral(cooperativa.estadoSituacionPatrimonial).format(
                    "(0,0.00)"
                  )}
                </Table.Cell>
                <Table.Cell textAlign="right">
                  {numeral(cooperativa.estadoResultados).format("(0,0.00)")}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>

          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell>Total de {eeconomicoFilter}</Table.HeaderCell>
              <Table.HeaderCell />
              <Table.HeaderCell />
              <Table.HeaderCell textAlign="right">
                {numeral(
                  coops.reduce((prev, curr) => {
                    return (
                      prev + numeral(curr.estadoSituacionPatrimonial).value()
                    );
                  }, 0)
                ).format("(0,0.00)")}
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="right">
                {numeral(
                  coops.reduce((prev, curr) => {
                    return prev + numeral(curr.estadoResultados).value();
                  }, 0)
                ).format("(0,0.00)")}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </Container>
    );
  }
}

export default ReporteAvanzado;



// WEBPACK FOOTER //
// ./client/components/pages/informes/ReporteEconomicoView.js